module.exports = __webpack_public_path__ + "img/about_01.3754a4ee.png";